import { ReactNode } from "react";
import { DeskSubnavContext, DeskSubnavContextValue } from "@/contexts/deskSubnavContext";

export function DeskSubnavProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: DeskSubnavContextValue;
}) {
  return <DeskSubnavContext.Provider value={value}>{children}</DeskSubnavContext.Provider>;
}
